import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (!_ctx.state.loading)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.component), {
          key: 0,
          onOpenBox: _ctx.handleOpenBox,
          onCloseBox: _ctx.handleCloseBox
        }, null, 40, ["onOpenBox", "onCloseBox"]))
      : _createCommentVNode("", true)
  ]))
}